import { Avatar, Flex, Progress, Typography } from "antd";
import CustomTable from "../../../../components/CustomTable";
import StatusTag from "../../../../components/StatusTag";

const { Text } = Typography;

interface LearnerData {
  key: string;
  name: string;
  avatar: string;
  email: string;
  enrollmentDate: string;
  lesson: string;
  lastActive: string;
  certificate: "Issued" | "Not Issued";
  progress: number;
}

const mockLearners: LearnerData[] = [
  {
    key: "1",
    name: "Eleanor Pena",
    avatar: "https://i.pravatar.cc/150?u=eleanor",
    email: "example.user1@example.com",
    enrollmentDate: "2025-01-15",
    lesson: "41/55",
    lastActive: "2 hours ago",
    certificate: "Not Issued",
    progress: 85,
  },
  {
    key: "2",
    name: "Dianne Russell",
    avatar: "https://i.pravatar.cc/150?u=dianne",
    email: "example.user2@example.com",
    enrollmentDate: "2025-01-15",
    lesson: "41/55",
    lastActive: "2 hours ago",
    certificate: "Issued",
    progress: 85,
  },
  {
    key: "3",
    name: "Courtney Henry",
    avatar: "https://i.pravatar.cc/150?u=courtney",
    email: "example.user3@example.com",
    enrollmentDate: "2025-01-15",
    lesson: "41/55",
    lastActive: "2 hours ago",
    certificate: "Not Issued",
    progress: 85,
  },
  {
    key: "4",
    name: "Devon Lane",
    avatar: "https://i.pravatar.cc/150?u=devon",
    email: "example.user4@example.com",
    enrollmentDate: "2025-01-15",
    lesson: "41/55",
    lastActive: "2 hours ago",
    certificate: "Issued",
    progress: 85,
  },
  {
    key: "5",
    name: "Wade Warren",
    avatar: "https://i.pravatar.cc/150?u=wade",
    email: "example.user5@example.com",
    enrollmentDate: "2025-01-15",
    lesson: "41/55",
    lastActive: "2 hours ago",
    certificate: "Issued",
    progress: 85,
  },
  {
    key: "6",
    name: "Bessie Cooper",
    avatar: "https://i.pravatar.cc/150?u=bessie",
    email: "example.user6@example.com",
    enrollmentDate: "2025-01-15",
    lesson: "41/55",
    lastActive: "2 hours ago",
    certificate: "Not Issued",
    progress: 85,
  },
];

export default function Learners() {
  const columns = [
    {
      title: "Course name", // Matching the "typo" in screenshot, though it should be "Learner"
      dataIndex: "name",
      key: "name",
      render: (text: string, record: LearnerData) => (
        <Flex align="center" gap={12}>
          <Avatar src={record.avatar} size={40} />
          <Text className="font-medium text-theme-slate-800">{text}</Text>
        </Flex>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text: string) => (
        <Text className="text-theme-slate-500">{text}</Text>
      ),
    },
    {
      title: "Enrollment Date",
      dataIndex: "enrollmentDate",
      key: "enrollmentDate",
      render: (text: string) => (
        <Text className="text-theme-slate-500">{text}</Text>
      ),
    },
    {
      title: "Lesson",
      dataIndex: "lesson",
      key: "lesson",
      render: (text: string) => (
        <Text className="text-theme-slate-500">{text}</Text>
      ),
    },
    {
      title: "Last Active",
      dataIndex: "lastActive",
      key: "lastActive",
      render: (text: string) => (
        <Text className="text-theme-slate-500">{text}</Text>
      ),
    },
    {
      title: "Certificate",
      dataIndex: "certificate",
      key: "certificate",
      render: (status: string) => (
        <StatusTag
          value={status}
          className={
            status === "Issued"
              ? "bg-green-50 text-green-500 border-green-100"
              : "bg-slate-50 text-slate-500 border-slate-100"
          }
        />
      ),
    },
    {
      title: "Progress",
      dataIndex: "progress",
      key: "progress",
      render: (progress: number) => (
        <Flex vertical gap={4} className="min-w-[120px]">
          <Text className="text-xs font-semibold text-theme-slate-700">
            {progress}%
          </Text>
          <Progress
            percent={progress}
            showInfo={false}
            strokeColor="#1E293B"
            trailColor="#E2E8F0"
            strokeWidth={6}
          />
        </Flex>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <CustomTable
        tableTitle="Enrolled Learners"
        description="View all learners enrolled in your course and track their progress"
        columns={columns}
        dataSource={mockLearners}
        pagination={false} // Match screenshot for now or keep generic
      />
    </div>
  );
}
